import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: '',
  server: {},
  client: {
    PUBLIC_URL: z.string().default('/zapisy'),
    API_URL: z.string().default('https://go4robot.pl/api/v2'),
  },
  runtimeEnv: process.env,
});
